import React from "react";
import {
  DOCS_WRITES_MERGE_WRITES,
  DOCS_WRITES_RELATED_AND_NESTED_WRITES,
  DOCS_WRITES_PROGRAMMATIC_WRITES,
  DOCS_WRITES_PROGRAMMATIC_NESTED_WRITES,
  DOCS_WRITES_TEMPLATES_AND_CONDITIONAL_FIELDS,
} from "../../../../../router/RouterUtils";
import { Card, Text } from "@merge-api/merge-javascript-shared";
import FeatureCard from "../shared/FeatureCard";

const MergeWrites = () => {
  return (
    <Card className="p-6 mx-auto w-full lg:w-3/4 flex flex-col">
      <Text variant="h3" className="mb-1">
        Writing to Merge
      </Text>
      <Text as="p" className="mb-6 text-gray-40">
        Push data to integrated third-parties
      </Text>
      <Text variant="h4" as="p">
        Basic writes
      </Text>
      <Text as="div" className="mb-9">
        Here, we introduce universal concepts that allow you to execute writes for{" "}
        <strong>most</strong> — but not all — third-party platforms and Linked Accounts.
      </Text>
      <FeatureCard icon={<></>} title="Writing to Merge" docsPath={DOCS_WRITES_MERGE_WRITES}>
        <Text>Make POST requests to Merge to write data to third-party platforms</Text>
      </FeatureCard>
      <FeatureCard
        icon={<></>}
        title="Related and nested writes"
        docsPath={DOCS_WRITES_RELATED_AND_NESTED_WRITES}
      >
        <Text>
          Write data to third-party platforms with relations to existing and new Common Model
          instances
        </Text>
      </FeatureCard>
      <Text variant="h4" className="mt-9" as="p">
        Advanced writes
      </Text>
      <Text as="p">Writes are unified across all of our third-party platforms.</Text>
      <Text as="p">
        However, some platforms require an additional piece of Merge&apos;s advanced functionality
        to support them.
      </Text>
      <Text as="div" className="mb-9">
        Here, we introduce programmatic concepts that make heavy use of an endpoint we call{" "}
        <code>/meta</code> to handle writes for <strong>all</strong> third-party platforms and
        Linked Accounts.
      </Text>
      <FeatureCard
        icon={<></>}
        title={
          <>
            Programmatic writes with <code className="bg-transparent">/meta</code>
          </>
        }
        docsPath={DOCS_WRITES_PROGRAMMATIC_WRITES}
      >
        <Text>
          Use <code className="bg-transparent">/meta</code> to programmatically form and validate
          POST requests to write standardized or integration-specific / Linked Account-specific
          model fields
        </Text>
      </FeatureCard>
      <FeatureCard
        icon={<></>}
        title={
          <>
            Programmatic nested writes with <code className="bg-transparent">/meta</code>
          </>
        }
        docsPath={DOCS_WRITES_PROGRAMMATIC_NESTED_WRITES}
      >
        <Text>
          Use <code className="bg-transparent">/meta</code> to create related Common Model instances
          (through nesting) with standardized or integration-specific / Linked Account-specific
          fields
        </Text>
      </FeatureCard>

      <FeatureCard
        icon={<></>}
        title="Templates and conditional fields"
        docsPath={DOCS_WRITES_TEMPLATES_AND_CONDITIONAL_FIELDS}
      >
        <Text>
          Use <code className="bg-transparent">/meta</code> to determine which specific model fields
          are available based on your user&apos;s input in another field
        </Text>
      </FeatureCard>
    </Card>
  );
};

export default MergeWrites;
